import { render, staticRenderFns } from "./AuthRedirect.vue?vue&type=template&id=29d58606&scoped=true&"
import script from "./AuthRedirect.vue?vue&type=script&lang=ts&"
export * from "./AuthRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d58606",
  null
  
)

export default component.exports